// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/i18n/captionLabel.ts

import { OutRefBookmarkKind } from '../../modules/documents/tiptap/nodes/caption/constants';
import { TMap } from '../types';

const de: TMap<OutRefBookmarkKind, string> = Object.freeze({
  [OutRefBookmarkKind.FIGURE]: 'Abbildung',
  [OutRefBookmarkKind.TABLE]: 'Tabelle',
} as const);

const en: TMap<OutRefBookmarkKind, string> = Object.freeze({
  [OutRefBookmarkKind.FIGURE]: 'Figure',
  [OutRefBookmarkKind.TABLE]: 'Table',
} as const);

export const captionLabelMap: TMap<string, TMap<OutRefBookmarkKind, string>> = Object.freeze({
  DE: de,
  EN: en,
} as const);
